import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import TeacherCombo from '../combos/TeacherCombo';
import SchoolClassCombo from '../combos/SchoolClassCombo';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import StudentSelector from '../school/StudentSelector';
import EmployeeSelector from '../school/EmployeeSelector';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';



export default function ShowAnnounceSimple(props) {
    const toast = useRef(null);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [items, setItems] = useState([]);
  const [checkboxes, setCheckBoxes] = useState([]);
    

    useEffect(() => {
      var params = {login:util.getTrustedUser(), searchText:"", lastIndex:0, pageSize:0};
      var url = config.Server+`/school/announce-simple/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  
                  var checks = [];
                  

                  for(var i=0;i<response.length;i++){
                    if(response[i].color == "#dadada")response[i].color2 = "#686666ff";
                    if(response[i].color == "#d9e2f3")response[i].color2 = "#213f79";
                    if(response[i].color == "#fbe4d5")response[i].color2 = "#6d3a18";
                    if(response[i].color == "#fff2cc")response[i].color2 = "#6a530e";
                    if(response[i].color == "#e2efd9")response[i].color2 = "#396917";
                    checks.push(false);
                  }
                  setCheckBoxes(checks);
                  response = getAnnounceVisibleStates(response);
                  setItems(response);
                  
                  
              }
              else{
                  //setErrorMessage(response.message);
                  //setErorVisible(true);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
          });
    }, []);
  const getAnnounceVisibleStates = function(list){
    var str = localStorage.getItem("AnnounceStates");
    for(var i=0;i<list.length;i++){
      list[i]["visible"] = true;
    }
    if(props.onlyShowNew == false){
      return list;
    }
    if(str){
      var states = JSON.parse(str);
      console.log("states is>", states)
      console.log("list is>", list)
      if(states){
        for(var i=0;i<list.length;i++){
          for(var j=0;j<states.length;j++){
            if((list[i].id == states[j].id)
              &&(list[i].createDate == states[j].createDate)
              &&(list[i].createTime == states[j].createTime)){
                list[i]["visible"] = false;
              }
          }
        }
      }
    }
    return list;
  }
  const setAnnonceVisibleState = function(e, index, id, date, time){
    var tmp = [...checkboxes];
    tmp[index] = e.checked;
    setCheckBoxes(tmp);
    var str = localStorage.getItem("AnnounceStates");
    var states = [];
    if(str){
      states = JSON.parse(str);
      if(!states) states = [];
    }
    for(var j=0;j<states.length;j++){
      if(states[j].id == id){
        states.splice(j, 1);
        break;
      }
    }
    if(e.checked){
      states.push({id:id, createDate:date, createTime:time});
    }
    localStorage.setItem("AnnounceStates", JSON.stringify(states));
  }
  return(  
    <> 
      {
        items.map((an, index)=>{
          return(
            <>
            {
              an.visible?
              <Row style={{marginTop:"30px"}}>
                <Col>
                  <div style={{width:"100%", backgroundColor:an.color, color:"#000", border:"1px solid "+an.color2, borderRadius:"5px", position:"relative"}}>
                    <div style={{borderTopLeftRadius:"5px",borderTopRightRadius:"5px", fontWeight:"bold", backgroundColor:an.color2, color:"#FFF", width:"calc(100% - 0px)", padding:"10px 5px", margin:"0px"}}>{an.title}</div>
                    <div style={{color:"#000", width:"calc(100% - 0px)", padding:"20px 5px", margin:"0px"}}>                    
                      {an.text.split("\n").map((line, index) => (
                        <React.Fragment key={index}>
                          {line}
                          <br />
                        </React.Fragment>
                      ))}                    
                    </div>
                    {
                      props.onlyShowNew?
                    <div style={{color:"#909090", fontSize:"8pt", width:"calc(100% - 0px)", borderTop:"1px dotted #b0b0b0", padding:"5px 5px", margin:"0px", height:"30px"}}>                    
                        <div className="flex align-items-center" style={{marginTop:"0px", float:"right", height:"30px", overflow:"hidden"}}>
                            <Checkbox inputId={"chk_" + an.id} onChange={(e)=>{setAnnonceVisibleState(e, index, an.id, an.createDate, an.createTime)}} checked={checkboxes[index]} />
                            <label htmlFor={"chk_" + an.id} className="ml-2"> &nbsp;خواندم. مجددا نمایش نده</label>
                        </div>
                    </div>
                      :
                      <></>
                    }
                    <div style={{color:"#909090", fontSize:"8pt", width:"calc(100% - 0px)", borderTop:"1px dotted #b0b0b0", padding:"5px 5px", margin:"0px"}}>                    
                      زمان آخرین ویرایش: {util.toPersianDigits(util.SeperateDate(an.createDate)+"-"+ util.SeperateTime(an.createTime))}              
                    </div>
                  </div>
                </Col>
              </Row>
              :
              <></>
            }
            </>
          )
        })
      }
      
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <Toast ref={toast} />            
    </>  
  );
  
}
